import React from 'react';
import {Link} from 'react-router-dom';
import styles from './PageNotFound.module.scss';

const PageNotFound: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <h1>Page not found</h1>
      <div className={styles.buttonsRow}>
        <Link to="/">Homepage</Link>
      </div>
    </div>
  );
};

export default PageNotFound;
